// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'iview/dist/styles/iview.css' // 使用 CSS
import './assets/common.less' // 使用 CSS
import iView from 'iview'
import VueRouter from 'vue-router'
import routes from './router/index'
import List from './components/common/List.vue'
import RecommendList from './components/common/RecommendList.vue'
import CheckBox from './components/common/CheckBox.vue'
import RuleButton from './components/common/RuleButton.vue'
import AppConfig from './AppConfig'
import Store from './plugins/Store'
import Logger from './plugins/Logger'
import Helper from './plugins/Helper'
import Http from './plugins/Http'
import Constant from './plugins/Constant'
import DateUtil from './plugins/DateUtil'
import TableStyle from './plugins/TableStyle'
import PhoneArea from './plugins/PhoneArea'
import VDistpicker from 'v-distpicker'
import moment from 'moment'
import numeral from 'numeral'
import TimeZone from './plugins/TimeZone'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as Quill from 'quill'
import Audio from './plugins/Audio'
import uploader from 'vue-simple-uploader'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import d from './directive/permissions'
import domainHelper from './tools/domainHelper'

// 包装 window.open，自动替换非静态资源URL域名
(function () {
  var _open = window.open
  window.open = function (url, target, features) {
    if (typeof url === 'string' && domainHelper.isQuqukidDomain()) {
      url = domainHelper.replaceDomain(url)
    }
    return _open.call(window, url, target, features)
  }
})()

Quill.register('formats/audio', Audio)

import AdminUserSelect from './components/common/AdminUserSelect.vue'
import TeacherSelect from './components/common/TeacherSelect.vue'
import PhoneAreaSelect from './components/common/PhoneAreaSelect.vue'
import CitySelect from './components/common/CitySelect.vue'
import MultiUpload from './components/common/MultiUpload.vue'
import TimeZoneSelect from './components/common/TimeZoneSelect.vue'

import ImageUpload from './components/common/ImageUpload.vue'
import ImageUploadNew from '@/components/common/ImageUploadNew'
import multipleImageUpload from './components/common/multipleImageUpload.vue'
import FileUpload from './components/common/FileUpload.vue'
import StudentSelect from './components/common/StudentSelect.vue'
import ActivitySelect from '@/components/common/ActivitySelect'
import SalesAdviserSelect from '@/components/common/SalesAdviserSelect'
import ChannelSelect from '@/components/common/ChannelSelect'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'flag-icons/css/flag-icons.css'

Vue.prototype.$moment = moment
Vue.prototype.$numeral = numeral

const router = new VueRouter({
  mode: 'hash',
  routes,
})

router.beforeEach((to, from, next) => { // beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title
  }
  const search = new URLSearchParams(window.location.search)
  const authCode = search.get('authCode') || search.get('code')
  if (authCode && to.path !== '/login') {
    const state = search.get('state')
    window.history.replaceState(null, '', window.location.origin + window.location.pathname + window.location.hash)
    const query = {authCode: authCode}
    if (state) {
      query.state = state
    }
    next({path: '/login', query: query})
    return
  }
  next()  // 执行进入路由，如果不写就不会进入目标页
})


Vue.use(uploader)
Vue.use(iView)
Vue.use(VueRouter)
Vue.use(AppConfig)
Vue.use(Store)
Vue.use(Logger)
Vue.use(Helper)
Vue.use(Constant)
Vue.use(DateUtil)
Vue.use(TableStyle)
Vue.use(PhoneArea)
Vue.use(CitySelect)
Vue.use(Http, {router: router})
Vue.use(ElementUI)
Vue.use(TimeZone)
Vue.use(VueQuillEditor)
Vue.use(Viewer)
Vue.use(d)
Viewer.setDefaults({
  // 底部缩略图
  navbar: false,
  // 底部工具栏
  toolbar: false,
  // 右上角按钮
  button: false,
  // 当前图片标题
  title: false,
  // 是否可以移动
  movable: true,
  // 是否可以缩放
  zoomable: true,
  // 使用 CSS3 过度
  transition: false
})

Vue.component('List', List)
Vue.component('CheckBox', CheckBox)
Vue.component('AdminUserSelect', AdminUserSelect)
Vue.component('TeacherSelect', TeacherSelect)
Vue.component('PhoneAreaSelect', PhoneAreaSelect)
Vue.component('CitySelect', CitySelect)
Vue.component('RuleButton', RuleButton)

Vue.component('ImageUpload', ImageUpload)
Vue.component('ImageUploadNew', ImageUploadNew)
Vue.component('multipleImageUpload', multipleImageUpload)
Vue.component('FileUpload', FileUpload)
Vue.component('MultiUpload', MultiUpload)
Vue.component('RecommendList', RecommendList)
Vue.component('v-distpicker', VDistpicker)
Vue.component('TimeZoneSelect', TimeZoneSelect)
Vue.component('StudentSelect', StudentSelect)
Vue.component('ActivitySelect', ActivitySelect)
Vue.component('SalesAdviserSelect', SalesAdviserSelect)
Vue.component('ChannelSelect', ChannelSelect)

Vue.prototype.$domainHelper = domainHelper

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App},
})

export default new Vue({
  name: 'centerDealVue',
})



// WEBPACK FOOTER //
// ./src/main.js